import { FC, FormEventHandler, PropsWithChildren, ReactNode } from "react";

import { Box, createStyles, Text, Title } from "@mantine/core";

const useStyles = createStyles((t) => ({
  formWrapper: {
    display: "flex",
    gap: t.spacing.md,
    background: "white",
    padding: t.spacing.lg,
    flexDirection: "column",
  },
}));

export const SettingsForm: FC<
  {
    title: string;
    description: ReactNode;
    onSubmit?: FormEventHandler<HTMLFormElement>;
  } & PropsWithChildren
> = ({ children, description, title, onSubmit }) => {
  const { classes } = useStyles();
  return (
    <>
      <Box>
        <Title order={2}>{title}</Title>
        <Text color="dimmed">{description}</Text>
      </Box>
      <form onSubmit={onSubmit}>
        <Box className={classes.formWrapper}>{children}</Box>
      </form>
    </>
  );
};
